import React, { useEffect, useState } from "react";
import { appApiHandler } from "../../api/appApiHandler";
import "./BankDetails.css";
import InlineLoader from "../../components/loader/InlineLoader/index";
import HomeHeader from "../../components/header/HomeHeader";
import CommonFooter from "../../components/footer/CommonFooter";
import Breadcrumb from "../../components/breadcrumb";
import { useSelector } from "react-redux";
import EmptyState from "../../components/EmptyState";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BankDetails = () => {
  const navigate = useNavigate(); 
  const [bankDetails, setBankDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.authState);

  const getBankDetails = async () => {
    setLoading(true);
    const response = await appApiHandler.getAdminBankDetails();
    if (response?.status === 200 && response?.data) {
      setBankDetails(response?.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getBankDetails();
  }, []);

  return (
    <div className="page-container">
      <HomeHeader />
      <div className="page-content">
        <Breadcrumb
          items={[
            {
              label: "Home",
              path: "/",
            },
            {
              label: "Bank Details",
              isActive: true,
            },
          ]}
        />
        {!isLoggedIn ? (
          <EmptyState
            icon={FaUser}
            title="Sign In to Continue"
            description="please login with your account. Enjoy a seamless shopping experience with personalized recommendations and more!"
            buttonText="Login"
            onButtonClick={() => navigate("/login")}
            iconSize={48}
          />
        ) : (
          loading ? (<InlineLoader text="Loading bank details..."/>): (
          <main className="bank-details-main">
            {!bankDetails ? (
              <div className="empty-container">
                <p className="empty-text">No store bank details added</p>
              </div>
            ) : (
              <div className="bank-details-card">
                {bankDetails?.bank_name && (
                  <div className="detail-row">
                    <span className="detail-label">Bank Name</span>
                    <span className="detail-value">{bankDetails?.bank_name}</span>
                  </div>
                )}
                {bankDetails?.account_number && (
                  <div className="detail-row">
                    <span className="detail-label">Account No</span>
                    <span className="detail-value">
                      {bankDetails?.account_number}
                    </span>
                  </div>
                )}
                {bankDetails?.ifsc_code && (
                  <div className="detail-row">
                    <span className="detail-label">IFSC Code</span>
                    <span className="detail-value">{bankDetails?.ifsc_code}</span>
                  </div>
                )}
                {bankDetails?.branch && (
                  <div className="detail-row">
                    <span className="detail-label">Branch</span>
                    <span className="detail-value">{bankDetails?.branch}</span>
                  </div>
                )}
                {bankDetails?.upi && (
                  <div className="detail-row">
                    <span className="detail-label">UPI</span>
                    <span className="detail-value">{bankDetails?.upi}</span>
                  </div>
                )}
              </div>
            )}
          </main>
          )
        )}
      </div>
      <CommonFooter />
    </div>
  );
};

export default BankDetails;
